<template lang="pug">
v-col(class="tw-bg-white tw-rounded-md px-4 fill-height d-flex flex-column min-h-0 flex-grow-1 ")
  v-row(no-gutters align="center" justify-space-between class=" flex-shrink-1 flex-grow-0")
    v-col
      span(class=" tw-text-lg tw-font-bold tw-capitalize") {{ $t('Common.newLeads') }}
    v-col(class="text-right")
      v-btn(
        outlined
        text
        :ripple="false"
        color="blue-grey lighten-2"
        :to="{ name: 'inbox' }"
      )
        span(class="tw-font-medium") {{ $t('Common.viewAll') }}
  v-row(no-gutters class=" d-flex flex-column flex-grow-1 tw-max-h-full flex-shrink-0 tw-min-h-0 ")
    v-col(class="flex-grow-1 d-flex overflow-auto flex-column flex-shrink-0 min-h-0")
      v-sheet(v-if="leads.length && !loading > 0" elevation="0" transition="fade-transition")
        kubiqa-leads-list-item(v-for="lead in leads" :key="lead.id" :lead="lead")
      div(v-if="!loading && leads.length == 0" class=" tw-flex tw-justify-center tw-h-full tw-items-center")
        kubiqa-misc-empty-state(
          :title="$t('Common.emptyStates.inboxTitle')"
          :description="$t('Common.emptyStates.noNewLeads')"
          compact
          icon="mdi-account-arrow-left-outline"
        )
      div(v-if="loading")
        v-skeleton-loader(v-for="a in 5" :key="a.key" type="list-item-avatar-two-line")
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    leads() {
      return this.$store.getters['leads/list'];
    },
    loading() {
      return this.$store.getters['loading'];
    },
  },
  mounted() {
    let filters = new URLSearchParams();
    filters.append('filter[status]', 'new');
    filters.append('include', 'property');
    this.$store.dispatch('leads/list', filters);
  },
};
</script>
